import { AppLayout, Box, Button, ContentLayout, SpaceBetween } from '@amzn/awsui-components-core';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import peccyImage from 'src/images/peccy-permissions-gate.png';
import { navigateWithEmbedParams } from 'src/utils/navigation-utils';

// Constants moved to separate object for better maintainability
const MESSAGES = {
  HEADER: "Oops! It looks like Peccy couldn't find your access permission. 🦙🛑",
  SUBHEADER: 'Submit a request to gain entry!',
  BUTTON_TEXT: 'Submit an Access Request'
} as const;

export const AccessRestricted: React.FC = () => {
  const navigate = useNavigate();

  const handleAccessRequest = useCallback(() => {
    navigateWithEmbedParams(navigate, '/request-access');
  }, [navigate]);

  return (
    <AppLayout
      headerSelector="#h2"
      navigationHide={true}
      toolsHide={true}
      contentType="dashboard"
      content={
        <div className="xpt-no-access-layout-content">
          <ContentLayout>
            <Box margin={{ top: 'xl', left: 'l', right: 'l' }} padding={{ left: 'l', right: 'l' }}>
              <SpaceBetween size="l" className="access-restricted-container">
                <Box variant="h2">{MESSAGES.HEADER}</Box>
                <Box variant="h4">{MESSAGES.SUBHEADER}</Box>
                <Button ariaLabel="Request access" onClick={handleAccessRequest}>
                  {MESSAGES.BUTTON_TEXT}
                </Button>
                <img src={peccyImage} alt="Peccy Permissions Gate" className="access-restricted-image" />
              </SpaceBetween>
            </Box>
          </ContentLayout>
        </div>
      }
    />
  );
};

export default AccessRestricted;
